<div class="form-group">
	<parc-maintenance-checkbox-list
		[id]="'choixMaintenance'"
		[labelClass]="'col-md-1'"
		[fieldClass]="'col-md-3'"
		[resetCommands]="resetMaintenanceCommands$"
		(itemDeselected)="maintenanceDeselected($event)"
		(itemSelected)="maintenanceSelected($event)"
		>
	</parc-maintenance-checkbox-list>
	<parc-technologie-checkbox-list
		[id]="'choixTechnologie'"
		[labelClass]="'col-md-1'"
		[fieldClass]="'col-md-3'"
		[resetCommands]="resetTechnologieCommands$"
		(itemDeselected)="technologieDeselected($event)"
		(itemSelected)="technologieSelected($event)"
		(selectionChange)="onTechnologieSelectionChange($event)"
		>
	</parc-technologie-checkbox-list>
	
	<parc-hyperviseur-checkbox-list
		*ngIf="afficherFiltreHyperviseur"
		[id]="'choixHyperviseur'"
		[labelClass]="'col-md-1'"
		[fieldClass]="'col-md-3'"
		[resetCommands]="resetHyperviseurCommands$"
		(itemDeselected)="hyperviseurDeselected($event)"
		(itemSelected)="hyperviseurSelected($event)"
		>
	</parc-hyperviseur-checkbox-list>
</div>
<div>
	<ng-template ngFor let-antenne [ngForOf]="antennes">
		<div>
			<label class="checkbox-inline">
				<input
					type="checkbox"
					[id]="'antenne_' + antenne.entity.id"
					[ngModel]="antenne.selected"
					(ngModelChange)="onAntenneChangedByUser(antenne, $event)"
					>
				Antenne <strong>{{ antenne.entity.nom }}&nbsp;:</strong>
			</label>
		</div>
		<div class="indented">
			<ng-template ngFor let-parc [ngForOf]="antenne.parcs">
				<div>
					<label class="checkbox-inline">
						<input
							type="checkbox"
							[id]="'parc_' + parc.entity.id"
							[ngModel]="parc.selected"
							(ngModelChange)="onParcChangedByUser(antenne, parc, $event)"
							>
						Parc <strong>{{ parc.entity.code }} ({{ parc.entity.description }} - <span class="red">{{ parc.entity.energie }}</span> - <span class="green">{{ parc.entity.type }}</span>)</strong>&nbsp;:
					</label>
					<ng-template ngFor let-ouvrage let-index="index" [ngForOf]="parc.ouvrages">
						<label class="checkbox-inline">
							<input
								type="checkbox"
								[id]="'ouvrages_' + ouvrage.entity.id"
								[ngModel]="ouvrage.selected"
								(ngModelChange)="onOuvrageChangedByUser(antenne, parc, null, ouvrage, $event)"
								>
							{{ ouvrage.entity.nom }}{{ index < (parc.ouvrages.length - 1) ? ',' : '' }}
						</label>
					</ng-template>
				</div>
				<div class="indented">
					<div *ngFor="let sousparc of parc.sousParcs">
						<label class="checkbox-inline">
							<input
								type="checkbox"
								[id]="'sp_' + sousparc.entity.id"
								[ngModel]="sousparc.selected"
								(ngModelChange)="onSousParcChangedByUser(antenne, parc, sousparc, $event)"
								>
							Sous-parc <strong>{{ sousparc.entity.code }}</strong>&nbsp;:
						</label>
						<ng-template ngFor let-ouvrage let-index="index" [ngForOf]="sousparc.ouvrages">
							<label class="checkbox-inline">
								<input
									type="checkbox"
									[id]="'ouvrages_' + ouvrage.entity.id"
									[ngModel]="ouvrage.selected"
									(ngModelChange)="onOuvrageChangedByUser(antenne, parc, sousparc, ouvrage, $event)"
									>
								{{ ouvrage.entity.nom }}{{ index < (sousparc.ouvrages.length - 1)  ? ',' : '' }}
							</label>
						</ng-template>
					</div>
				</div>
			</ng-template>
		</div>
	</ng-template>
</div>